<template>
<div class="dashboard">
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 v-show="$vuetify.breakpoint.mdAndUp">
        <a href="http://www.kitco.com/connecting.html">
            <img src="http://www.kitconet.com/images/quotes_7a.gif" border="0" alt="[Most Recent Quotes from www.kitco.com]"></img>
          </a>
      </v-flex>
      <v-flex xs12 v-show="$vuetify.breakpoint.smAndDown">
        <A HREF="http://www.kitco.com/connecting.html">
            <IMG SRC="http://www.kitconet.com/images/quote_m_spot.gif" BORDER="0" ALT="[Most Recent Quotes from www.kitco.com]"></IMG>
          </A>
      </v-flex>
    </v-layout>
    <v-layout wrap  v-if="loadedData">
      <v-flex sm6 xs12 md6 lg3 px-3>
        <material-stats-card color="orange" icon="Pt" title="Platino" :value="currentValues.platinum_price" sub-icon="mdi-calendar" sub-text="" :brokervalues="platinum_prices" />
      </v-flex>

      <v-flex sm6 xs12 md6 lg3 px-3>
        <material-stats-card color="green" icon="Pl" title="Paladio" :value="currentValues.paladium_price" sub-icon="mdi-calendar" sub-text="" :brokervalues="paladium_prices" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3 px-3>
        <material-stats-card color="red" icon="Rh" title="Rodio" :value="currentValues.rodium_price" sub-icon="mdi-calendar" sub-text="" :brokervalues="rodium_prices" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3 px-3>
        <material-stats-card color="info" icon="Dll" title="Dolar" :value="currentValues.dollar_price" sub-icon="mdi-calendar" sub-text="" :brokervalues="dollar_prices" />
      </v-flex>
    </v-layout>

  </v-container>
</div>
</template>

<script>
import {
  getBasePrices,
  getHistoricBasePrices,
} from '../services/base_prices';

export default {
  name: 'Dashboard',
  data() {
    return {
      loadedData: false,
      cotizations: [{}],
      paladium_prices: [],
      platinum_prices: [],
      rodium_prices: [],
      dollar_prices: [],
      currentValues: {},
    };
  },
  watch: {
    cotizations(newValues, oldValues) {
      this.loadedData = false;
      for (const index in newValues) {
        if (newValues.hasOwnProperty(index)) {
          this.paladium_prices.push(newValues[index].paladium_price);
          this.platinum_prices.push(newValues[index].platinum_price);
          this.rodium_prices.push(newValues[index].rodium_price);
          this.dollar_prices.push(newValues[index].dollar_price);
        }
      }
      this.loadedData = true;
    },
  },

  mounted() {
    getBasePrices().
    then((results) => {
      this.currentValues = results.data;
    });
    const that = this;
    getHistoricBasePrices()
      .then((results) => {
        that.cotizations = results.data.sort((a, b) =>
          (a.created_on > b.created_on) ? 1
          : ((a.created_on < b.created_on) ? -1 : 0));
      });

  },
  computed: {
    brokerInfo() {
      return Array.from({
        length: 10,
      }, this.cotization);
    },
  },
  methods: {
    cotization() {
      return Math.ceil(Math.random() * (100 - 80) + 80);
    },
  },
};
</script>
